import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  type FieldExtensionOptions,
} from '@backstage/plugin-scaffolder-react';
import { RepoNameFromApp } from './RepoNameFromAppExtension';
import { validateRepoUrlAccess } from '../githubAccessValidation';

// Exported as plain options as well as a provided extension. The stock /create
// route registers the extension as a React child; anything rendering a
// template outside that route needs the options (see ../extensions.ts).
export const repoNameFromAppFieldOptions: FieldExtensionOptions<any, any> = {
  name: 'RepoNameFromApp',
  component: RepoNameFromApp,
  validation: validateRepoUrlAccess,
};

export const RepoNameFromAppFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(repoNameFromAppFieldOptions),
);
